import Controller from 'controllers/controller';
// import AudioController from 'controllers/audio';
import Binder from 'tools/binder';
import Animator from 'tools/animator';
import {Power2} from 'tools/gsap';

class HappeningController extends Controller {
    constructor(app, happening) {
        super(app);
        
        this.happening = happening;
        this.elements = { };
        this.binder = new Binder(this);
        this.animator = new Animator({
            elements: this.elements,
            duration: 0.4,
            ease: Power2.easeInOut
        });
        
        this.cacheElements();
        this.attachEvents();
        this.resizeButton();

        // if (this.elements.audioElement) {
        //     this.audioControlsController = this.app.make(AudioController, this.elements.audioElement);
        // }
    }
    
    cacheElements() {
        this.elements.slideInner = this.happening.querySelector('.slide-inner');
        this.elements.textOverlay = this.happening.querySelector('.text-overlay');
        this.elements.fadedLayer = this.happening.querySelector('.faded-layer');
        this.elements.fullLayer = this.happening.querySelector('.full-layer');
        // this.elements.audioElement = this.happening.querySelector('.audio-player');
        this.elements.happeningDate = this.happening.querySelector('.happening-date');
        this.elements.moreInfo = this.happening.querySelector('.happening-date .button');
    }
    
    attachEvents() {
        this.app.bus.on('fonts-loaded', this.binder.bind('onFontsLoaded'));
        window.addEventListener('resize', this.onWindowResize);
        this.elements.slideInner.addEventListener('mouseenter', this.binder.bind('onMouseEnter'));
        this.elements.slideInner.addEventListener('mouseleave', this.binder.bind('onMouseLeave'));
    }

    onWindowResize() {
        this.resizeButton();
    }

    onFontsLoaded() {
        this.resizeButton();
    }
    
    onMouseEnter() {
        if ( ! this.app.isTouchDevice) {
            this.expand();
        }
    }
    
    onMouseLeave() {
        if ( ! this.app.isTouchDevice) {
            this.contract();
        }
    }

    expand() {
        this.animator.to('textOverlay', {
            y: '-18.1%'
        });

        this.animator.to('fadedLayer', {
            opacity: 0.001
        });

        this.animator.to('fullLayer', {
            opacity: 1
        });
    }

    contract() {
        this.animator.to('textOverlay', {
            y: '0%'
        });

        this.animator.to('fadedLayer', {
            opacity: 1
        });

        this.animator.to('fullLayer', {
            opacity: 0.001
        });
    }

    resizeButton() {
        if (this.elements.moreInfo) {
            let diff = this.elements.happeningDate.offsetHeight - this.elements.moreInfo.offsetHeight;

            this.elements.moreInfo.style.marginTop = (diff / 2) + 'px';
        }
    }
}

export default HappeningController;